import EditPlatformPopup from "./EditPlatformPopup";
export default EditPlatformPopup;